import { is, number } from "superstruct"
import { action, atom } from "@reatom/core"
import debounce from "lodash.debounce"
import { onConnect } from "@reatom/hooks"

import { ctx } from "modules/PsyCatalog/common/ctx"
import { Services } from "modules/PsyCatalog/common/services"

export function createRangeField(
    { UpdateUrl, CurrentQuery, FieldStatus }: Services,
    field: "price" | "age" = "price"
) {
    const initialValue =
        field === "price" ? CurrentQuery.getPriceRange() : CurrentQuery.getAgeRange()
    const inputValue = atom<number[]>(initialValue)
    const update = action((ctx, value: number[]) => {
        inputValue(ctx, value)
    })
    const debounced = debounce(UpdateUrl.run, 300, { trailing: true })

    function onChange(value: number | number[]) {
        update(ctx, Array.isArray(value) ? value : initialValue)
        debounced()
    }

    function parseValue(value: unknown, defaultValue: number) {
        return is(value, number()) ? value : defaultValue
    }

    function updateFrom(value: number) {
        update(ctx, [value, ctx.get(inputValue)[1]])
    }

    function updateTo(value: number) {
        update(ctx, [ctx.get(inputValue)[0], value])
    }

    function parseAndUpdateFrom(value: unknown) {
        updateFrom(parseValue(value, initialValue[0]))
    }

    function parseAndUpdateTo(value: unknown) {
        updateTo(parseValue(value, initialValue[1]))
    }

    onConnect(inputValue, () => {
        update(ctx, field === "price" ? CurrentQuery.getPriceRange() : CurrentQuery.getAgeRange())
        if (field === "price") {
            FieldStatus.setReady("price_from")
            FieldStatus.setReady("price_to")
        } else {
            FieldStatus.setReady("age_from")
            FieldStatus.setReady("age_to")
        }
    })

    return { inputValue, onChange, update, parseValue, parseAndUpdateFrom, parseAndUpdateTo }
}
